<template>
    <div class="container" id="registerForm">
        <div class="row justify-content-md-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-body">
                        <h4>Registration</h4>
                        <form>
                            <div class="form-group">
                                <input type="text"
                                       v-model="email"
                                       @input="checkEmail"
                                       placeholder="E-Mail"
                                       class="form-control"
                                       :class="{error: mailCls}">
                            </div>
                            <div class="form-group">
                                <input type="text"
                                       v-model="username"
                                       @input="checkUsername"
                                       placeholder="Username"
                                       class="form-control"
                                       :class="{error: userCls}">
                            </div>
                            <div class="form-group">
                                <input type="password"
                                       v-model="password"
                                       @input="checkPassword"
                                       placeholder="Password"
                                       class="form-control"
                                       :class="{error: pwCls}">
                            </div>
                            <div class="form-group">
                                <input type="checkbox" v-model="ageverification" id="agever" value="1">
                                <label for="agever">I confirm that I am at least 18 years old</label>
                            </div>
                            <div class="form-group">
                                <input type="checkbox" v-model="termsaccepted" id="accept" value="1">
                                <label for="accept">I Agree to the <router-link :to="{name:'TermsConditions'}" target="_blank">Terms &amp; Conditions</router-link></label>
                            </div>
                            <button class="btn btn-primary" @click.prevent="register">Register</button>
                        </form>
                        <hr>
                        <p>Already registered? <router-link to="/login">Log in here!</router-link></p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

    //import debounce from 'debounce';
    const debounce = require('debounce');

    export default {
        name: 'RegistrationForm',
        data(){
            return {
                email: '',
                username: '',
                password: '',
                ageverification: false,
                termsaccepted: false,
                mailCls: '',
                userCls: '',
                pwCls: ''
            }
        },
        methods: {
            register(){
                if(!this.ageverification){
                    return this.$bus.$emit('error', 'You need to be at leat 18!');
                }
                if(!this.termsaccepted){
                    return this.$bus.$emit('error', 'Your ahve to Accept our Terms and Conditions');
                }
                if(this.username.length<3 || this.password.length <6 || this.email.indexOf('@')<2){
                    return this.$bus.$emit('error', 'Please provide valid User Data')
                }
                this.$api.register(this.email, this.username, this.password)
                    .then((res)=> {
                        return this.$store.dispatch('user/init', res.data.token);
                    })
                    .then((res)=> {
                        this.$bus.$emit('success', 'Your Account was Created! Have Fun!')
                        this.$router.push({name:'Intro'});
                    });
            },
            checkUsername: debounce(function(e){
                let val = e.target.value;
                this.$api.userExists(val).then((res)=>{
                    this.userCls = res.data.exists;
                })
            },600),
            checkEmail: debounce(function(e){
                let val = e.target.value;
                this.$api.mailExists(val).then((res)=>{
                    this.mailCls = res.data.exists;
                })
            },600),
            checkPassword: debounce(function(e){
                let val = e.target.value;
                this.pwCls = (val.length>0 && val.length<6)
            })
        },
        components:{

        }

    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/user/RegistrationForm.vue